import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/faq')({
  component: Outlet,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: 'breadcrumbs.faq',
      }),
    };
  },
});
